//#region src/version.ts
const version = "5.0.3";

//#endregion
export { version };
//# sourceMappingURL=version.js.map